// extracted by mini-css-extract-plugin
module.exports = {"description":"ChangeEmailPopup_description__3juJy","inputContainer":"ChangeEmailPopup_inputContainer__11A_C"};